<template>
  <div v-if="isLoaded">
    <h6>
      <b-input-group size="md">
        <b-form-input
          trim
          v-model="fileFilter"
          type="search"
          id="filterInput"
          placeholder="جستجو"
        ></b-form-input>
        <b-input-group-append>
          <!-- NOTE (b-delete) to delete the text of the search bar -->
          <b-button
            :disabled="!fileFilter"
            @click="fileFilter = ''"
            variant="danger"
            >حذف</b-button
          >
        </b-input-group-append>
      </b-input-group>
    </h6>

    <!-- NOTE (t-files) to show the proposal files -->
    <div class="custom-table">
      <b-table
        responsive
        small
        show-empty
        stacked="sm"
        tbody-tr-class="trClass"
        thead-class="thClass"
        :fields="fileFields"
        :items="files.filter((x) => x && x.url != '')"
        :filter="fileFilter"
        empty-text="فایلی برای نمایش وجود ندارد"
        empty-filtered-text="فایلی برای نمایش وجود ندارد"
        striped
      >
        <template v-slot:head()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.label }}
          </div>
        </template>
        <template v-slot:cell()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.value }}
          </div>
        </template>
        <template v-slot:cell(url)="data">
          <div style="text-align: center; vertical-align: middle">
            <!-- NOTE (<a>) to download the uploaded files by opening a new page -->
            <a
              v-if="data.value"
              class="btn bc-purple white--text"
              :href="data.value"
              target="_blank"
            >
              <v-icon class="white--text" small>mdi-download-outline</v-icon>
              دریافت فایل</a
            >
          </div>
        </template>
        <template v-slot:cell(index)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.index + 1 }}
          </div>
        </template>
        <div slot="table-busy" class="text-center text-danger my-2">
          <strong class="c-purple">در حال بارگذاری...</strong>
          <br />
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </b-table>
    </div>
  </div>
</template>

<script>
import VuePersianDatetimePicker from "vue-persian-datetime-picker"; // NOTE (IMPORT) date selection
import { MultiSelect } from "vue-search-select";
const sarmadGantt = () => import("./../components/sarmadGantt");
//const Review = () => import("c/ProposalReview");
import Select2 from "v-select2-component";
export default {
  props: ["files", "isLoaded"],
  components: {
    datePicker: VuePersianDatetimePicker,
    sarmadGantt, // NOTE (COMPONENT) component of sarmad gantt chart
    Select2, // NOTE (COMPONENT) component of select2 plugin
    MultiSelect,
  },
  data() {
    return {
      fileFields: [
        { key: "index", label: "#" },
        { key: "title", label: "عنوان فایل" },
        { key: "showName", label: "نام فایل" },
        // { key: "description", label: "توضیحات" },
        { key: "url", label: "دریافت" },
      ],
      fileItems: [],
      fileFilter: "",
      uploadedFiles: [],
    };
  },

  mounted() {},
};
</script>

<style lang="scss">
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
